import adminApi from "./adminApi";

export const cancelUpdate = (serial) =>
    adminApi.post(`/admin/inventory/${serial}/cancel-update`);
